import React, { useRef } from 'react';

import EditIcon from 'assets/actionPlan/edit.svg';
import SaveIcon from 'assets/actionPlan/save.svg';
import TimeLineArrowIcon from 'assets/actionPlan/timeLineArrow.svg';
import Input from 'common-ui/input';

import {
  Card,
  Container,
  EditImg,
  InputsGrid,
  SaveButton,
  SaveButtonWrapper,
  SaveImg,
  SubTitle,
  TimelineArrow,
  TimelineContainer,
  TimelineItem,
  TimelineLabel,
  TimelineRow,
  Title,
} from './PeriodTypeCard.styles';

const PeriodTypeCard = ({
  title,
  subTitle,
  showErrors,
  data,
  onChange,
  isReadOnly,
  onSave,
  onEdit,
  canEdit,
}) => {
  const submissionRef = useRef(null);
  const internalSave = () => {
    const normalizedData = {
      ...data,
      submissionTime: data.submissionTime ? Number(data.submissionTime) : data.submissionTime,
      reviewTime: data.reviewTime ? Number(data.reviewTime) : data.reviewTime,
      reminderValue: data.reminderValue ? Number(data.reminderValue) : data.reminderValue,
    };

    onSave(normalizedData);
  };
  const handleEdit = () => {
    onEdit();

    setTimeout(() => {
      const input = submissionRef.current?.querySelector?.('input') || submissionRef.current;
      input?.focus();
    }, 50);
  };
  return (
    <Container>
      <Card>
        <Title>{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
        <InputsGrid>
          <Input
            label="Employee Submission Time( in hours )"
            ref={submissionRef}
            required
            type="number"
            placeholder="Enter hours"
            width="304px"
            value={data.submissionTime || ''}
            onChange={(e) => onChange('submissionTime', e.target.value)}
            onWheel={(e) => e.target.blur()}
            readOnly={isReadOnly}
            error={showErrors?.submissionTime}
            disabled={isReadOnly}
          />
          <Input
            label="Manager Review Time( in hours )"
            required
            type="number"
            placeholder="Enter hours"
            width="304px"
            value={data.reviewTime || ''}
            onChange={(e) => onChange('reviewTime', e.target.value)}
            onWheel={(e) => e.target.blur()}
            readOnly={isReadOnly}
            error={showErrors?.reviewTime}
            disabled={isReadOnly}
          />
          <Input
            label="Reminder( in hours )"
            required
            type="number"
            placeholder="Enter hours"
            width="304px"
            value={data.reminderValue || ''}
            onChange={(e) => onChange('reminderValue', e.target.value)}
            onWheel={(e) => e.target.blur()}
            readOnly={isReadOnly}
            error={showErrors?.reminderValue}
            disabled={isReadOnly}
          />
        </InputsGrid>
        <TimelineContainer>
          <TimelineLabel>Timeline Preview</TimelineLabel>
          <TimelineRow>
            <TimelineItem $type="period">
              <span className="dot" /> Period Ends
            </TimelineItem>

            <TimelineArrow src={TimeLineArrowIcon} />

            <TimelineItem $type="submit">
              <span className="dot" /> {data.submissionTime && <>+{data.submissionTime}h </>}
              Submit
            </TimelineItem>

            <TimelineArrow src={TimeLineArrowIcon} />

            <TimelineItem $type="review">
              <span className="dot" /> {data.reviewTime && <>+{data.reviewTime}h </>} Review
            </TimelineItem>
            <SaveButtonWrapper>
              {canEdit && (
                <SaveButton onClick={internalSave} disabled={isReadOnly}>
                  <SaveImg src={SaveIcon} alt="save" />
                  Save Time Settings
                </SaveButton>
              )}
            </SaveButtonWrapper>
          </TimelineRow>
          {canEdit && isReadOnly && <EditImg src={EditIcon} alt="edit" onClick={handleEdit} />}
        </TimelineContainer>
      </Card>
    </Container>
  );
};

export default PeriodTypeCard;
